import { TextInput } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { PlayerFormFields } from "common/models/player.model";

type FormFieldTextInputProps<T> = {
  form: UseFormReturnType<T, (values: T) => T>;
  fontColor: string;

  name: string;
  isRequired: boolean;
  type: string;
  placeholder?: string;
  borderColor?: string;
};

const FormFieldTextInputV2 = ({
  form,
  fontColor,
  borderColor,
  name,
  isRequired,
  type,
  placeholder,
}: FormFieldTextInputProps<Partial<PlayerFormFields>>) => (
  <TextInput
    classNames={{
      root: "max-w-full my-1",
    }}
    key={name}
    name={name}
    size={"md"}
    placeholder={placeholder}
    styles={{
      label: {
        fontSize: "1rem",
        fontWeight: "bold",
        textTransform: "uppercase",
        color: `${fontColor}`,
        span: "blue",
      },
      input: {
        fontWeight: "normal",
        borderRadius: "10px",
        borderColor: borderColor,
        borderWidth: "2px",
      },
    }}
    required={isRequired}
    type={type}
    {...form.getInputProps(name)}
  />
);

export { FormFieldTextInputV2 };
